import * as Sentry from '@sentry/browser';

export function initErrorTracking(): void {
  window.addEventListener('unhandledrejection', (event) => {
    Sentry.captureException(event.reason ?? new Error('Unhandled promise rejection'));
  });

  window.addEventListener('error', (event) => {
    if (event.error) {
      Sentry.captureException(event.error);
    }
  });
}
